// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3iuZM","obliqueLineWrap":"membershipbadge_obliqueLineWrap__4FokC","obliqueLine":"membershipbadge_obliqueLine__kwYMn"};